/* eslint-disable react/jsx-filename-extension */
import { find, get, size } from 'lodash-es';
import React from 'react';
import cn from 'classnames';
import { checkIsEmpty } from '../../Utils/utils';

export const INPUT_1_CLASS = 'input-1';
export const INPUT_2_CLASS = 'input-2';

/**
 * get formatted value
 * @param {*} value
 */
export const getFormattedValue = ({ value = '', format }) => {
  try {
    const regExp = new RegExp(get(format, 'format[0]', ''));
    const localFormat = `${get(format, 'format[1]', '')}`;
    const newFormattedValue = value.replace(/ /g, '').replace(regExp, localFormat);
    return newFormattedValue;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`${e.stack}`);
  }
  return value;
};

/**
 *  get code from list
 * @param {*} param0
 */
export const getCodePrefix = ({ list, value }) => {
  const object = find(list, item => item.value === value);
  return get(object, 'code');
};

/**
 * set prefix '00' => '+'
 * @param {} param0
 */
export const setPrefix = (value = '') => {
  try {
    if (value.slice(0, 2) === '00') {
      return `+${value.slice(2, size(value))}`;
    }
    return value;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`${e.stack}`);
  }
  return value;
};

/**
 * @description return the Flag country image
 * @param {string} value - ISO 3166 country code
 * @returns {string} Flag country image
 */
// const getImageFlagCountry = value => {
//   // https://flagpedia.net/download/api
//   const countryCode = toLower(value.slice(0, 2));
//   const sizeFlag = 'w20';
//   const url = 'https://flagcdn.com';
//   const src = `${url}//${sizeFlag}/${countryCode}.png`;
//   const image = <img src={src} alt="flag-country" />;
//   return image;
// };

/**
 * @description return a Flag Country Emoji String
 * @param {string} countryCode - ISO 3166 country code
 * @returns {string} Flag Emoji
 */
export const getFlagEmoji = countryCode =>
  String.fromCodePoint(...[...countryCode.toUpperCase()].map(x => 0x1f1a5 + x.charCodeAt()));

/**
 * custom format option label '<Select>' input
 * @param {*} param0
 * @param {*} param1
 */
// eslint-disable-next-line react/prop-types
export const getFormatOptionLabelCustom = ({ value = '', label = '' }, { context }) => {
  try {
    const image = getFlagEmoji(value);
    const customLabel = `${label.slice(3, size(label))}`;
    const customStyle = {
      position: 'absolute',
      paddingTop: '3px',
    };
    switch (context) {
      case 'value':
        return <>{image}</>;
      case 'menu':
        return (
          <>
            {image}
            <span style={customStyle}>{customLabel}</span>
          </>
        );
      default:
        return <>{label}</>;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`${e.stack}`);
  }
  return <>{label}</>;
};

/**
 * get correct value
 */
export const getCorrectValue = ({ value, prefixCode }) => {
  if (!checkIsEmpty(value)) {
    return `${prefixCode}${value}`;
  }
  return undefined;
};

/**
 *  add class name
 * @param {*} param0
 */
export const addClassName = ({ inputClass, existError, showError }) =>
  cn(inputClass, {
    exist_error_style: existError,
    show_error_style: showError,
    valid_style: !existError && !showError,
  });
